<template>
  <div class="zv-nav-menu">
    <el-menu
      ref="navMenu"
      v-hidelast="handleResize"
      :default-active="activeIndexMenu"
      mode="horizontal"
      active-text-color="#2ECC71"
    >
      <template v-for="(item, i) in menuItems">
        <el-menu-item
          v-if="showRoute(item)"
          :key="i"
          :ref="item.name"
          v-visibility="{ item, handleItem }"
          :index="item.name"
          @click="onMenuClick(item)"
        >
          <router-link v-if="!item.blankLink" :to="{ name: item.name }">
            {{ item.title }}
          </router-link>
          <span v-else>{{ item.title }}</span>
          <template v-if="item.subtitle">
            <span v-if="getCount(item.subtitle)">
              ({{ getCount(item.subtitle) }})
            </span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
    <div
      v-if="menuItemsHidden.length"
      v-click-outside="onClickOutside"
      class="zv-nav-menu__dropdown"
    >
      <el-button
        plain
        type=""
        icon="el-icon-more"
        @click="visible = !visible"
      />

      <el-collapse-transition>
        <div v-if="visible" class="zv-nav-menu__sidemenu">
          <el-menu
            active-text-color="#2ECC71"
            background-color="#EEEEEE"
            :default-active="activeIndexMenu"
            @select="handleHiddenMenu"
          >
            <template v-for="(hidItem, j) in menuItemsHidden">
              <el-menu-item
                v-if="showRoute(hidItem)"
                :key="j"
                :index="hidItem.name"
                @click="visible = false"
              >
                {{ hidItem.title }}
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
import { SET_CLICKED_PAGE } from '@/store/ui'
import { headerMenuItems } from './constants'
import { mapGetters } from 'vuex'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'HeaderMenu',
  directives: {
    ClickOutside,
    visibility: {
      inserted(el, binding) {
        const { item, handleItem } = binding.value
        const rect = el?.getBoundingClientRect()
        const parentRect = el?.parentElement?.getBoundingClientRect() || {}

        if (rect.top > parentRect.top) {
          handleItem(item)
        }
      },
      componentUpdated(el, binding) {
        const { item, handleItem } = binding.value
        const rect = el?.getBoundingClientRect()
        const parentRect = el?.parentElement?.getBoundingClientRect() || {}

        if (rect.top > parentRect.top) {
          handleItem(item)
        }
      },
    },
    hidelast: {
      componentUpdated(el, binding) {
        setTimeout(() => {
          binding.value()
        }, 1000)
      },
    },
  },
  data() {
    return {
      activeIndexMenu: '1',
      visible: false,
      menuItems: headerMenuItems,
      menuItemsHidden: [],
      windowWidth: 0,
    }
  },
  computed: {
    ...mapGetters('approvements', ['totalCount']),
    activePage() {
      return this.$store.state.ui.page
    },
    isAdminOrCeo() {
      const admin = localStorage.getItem('admin-token')
      const ceo = localStorage.getItem('ceo-token')

      return (admin || ceo) && this.isAdminOrCeoRole
    },
  },
  watch: {
    $route: {
      handler: 'updateActive',
      immediate: true,
    },
    totalCount: {
      handler: 'updateTotalCount',
      immediate: true,
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    onClickOutside() {
      this.visible = false
    },
    handleItem(item) {
      this.menuItems = this.menuItems.filter(c => c.name !== item.name)
      this.menuItemsHidden.push(item)
    },
    updateTotalCount(value) {
      const menuItems = this.menuItems.concat(this.menuItemsHidden)
      const approvals = menuItems.find(c => c.name === 'Approvals')

      approvals.title = value
        ? `${approvals.titleTemplate} (${value})`
        : approvals.titleTemplate
    },
    showRoute(route) {
      return route.requireAdmin
        ? this.isAdminOrCeo
        : !route.action || this.canAction(route.action)
    },
    updateActive(route) {
      this.activeIndexMenu = route && route.name ? route.name : this.$route.name
    },
    handleResize() {
      try {
        // get the top of navMenu
        const navMenuTop = this.$refs?.navMenu?.$el.getBoundingClientRect().top
        // get the top of last item
        const lastItem = this.menuItems[this.menuItems.length - 1]

        if (this.$refs[lastItem.name]) {
          const lastItemTop =
            this.$refs[lastItem.name][0]?.$el.getBoundingClientRect().top

          // if big, move it to hidden
          if (lastItemTop > navMenuTop) {
            this.menuItems = this.menuItems.filter(
              c => c.name !== lastItem.name,
            )
            this.menuItemsHidden.unshift(lastItem)
          }
        }
      } catch (error) {
        console.log(`error resizing...`)
      }
    },
    onMenuClick(menuItem) {
      this.$store.dispatch(`ui/${SET_CLICKED_PAGE}`, { menuItem })
    },

    handleHiddenMenu(index) {
      let selected = this.menuItemsHidden.find(c => c.name === index)

      if (selected.blankLink) {
        const link = document.createElement('a')

        link.href = selected.blankLink
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        link.remove()
      } else {
        this.$router.push({ name: selected.name })
      }
    },
  },
}
</script>

<style lang="sass">
.el-menu.el-menu--horizontal
  border: none !important

.el-menu--horizontal>.el-menu-item
  text-transform: uppercase
  font-weight: bold !important
  font-size: 14px !important
  color: #2C3E50 !important

.el-tabs__item.is-active
  color: #2C3E50 !important

.el-tabs__active-bar
  height: 4px !important
  color: #2C3E50 !important
  background-color: #2ECC71 !important
</style>

<style lang="scss">
.zv-nav-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  &__dropdown {
    display: block;
  }
  &__sidemenu {
    position: absolute;
    text-transform: uppercase;
    top: 100%;
    right: 0;
    z-index: 9999;
    box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);

    .el-menu-item {
      padding: 0 20px !important;
    }
  }
  .el-menu-item {
    padding: 0;
    a {
      text-decoration: none;
      display: inline-flex;
      width: 100%;
      height: 100%;
      padding: 0 20px;
    }
  }
}
</style>
